import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  actions: {
    display: 'flex',
    gap: '0.75rem',
  },
  resetButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
